import { Chart } from '@hefe/models';
import { Select, Spin } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import ChartComponent from '../chart/chart.component';

interface ChartPickerComponentProps {
  charts: Chart[];
  loading?: boolean;
}

export default function ChartPickerComponent(props: ChartPickerComponentProps) {
  const { charts, loading } = props;

  const [selectedChart, setSelectedChart] = useState<number>();

  useEffect(() => {
    if (!selectedChart && charts?.length > 0) {
      setSelectedChart(charts[0].value);
    }
  }, [charts, selectedChart]);

  const currentChart = useMemo(() => {
    return charts?.find((chart) => chart.value === selectedChart);
  }, [charts, selectedChart]);

  const Picker = useMemo(() => {
    if (!charts || charts.length < 2) {
      return null;
    }

    return (
      <Select
        value={selectedChart}
        onChange={(value, option) => {
          setSelectedChart(value);
        }}
        options={charts}
        style={{ minWidth: 400, maxWidth: '80%', marginBottom: 24 }}
      />
    );
  }, [charts, selectedChart]);

  if (loading) {
    return (
      <Spin
        size="large"
        style={{ display: 'block', margin: 'auto', height: 200 }}
      />
    );
  }

  return (
    <>
      {Picker}
      {currentChart && <ChartComponent chart={currentChart} />}
    </>
  );
}
